// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"464":"50304c432b6bf875512a","928":"ed152239ec897754ef86"}[chunkId] + ".js";
};